import {
  addDays,
  format,
  isBefore,
  isValid,
  parseISO,
  startOfDay,
} from 'date-fns';

/**
 * Converts API date input to a valid Date, or returns null.
 *
 * `parseISO` preserves the local calendar day for date-only values such as
 * "2026-09-01", which matches the old Moment behavior for this application.
 */
export const toValidDate = (value) => {
  if (!value) {
    return null;
  }

  if (value instanceof Date) {
    return isValid(value) ? value : null;
  }

  if (typeof value !== 'string' && typeof value !== 'number') {
    return null;
  }

  const parsedDate =
    typeof value === 'string' ? parseISO(value) : new Date(value);

  return isValid(parsedDate) ? parsedDate : null;
};

/**
 * Formats a valid date with a date-fns Unicode format pattern.
 */
export const formatDate = (value, dateFormat) => {
  const date = toValidDate(value);

  if (!date || !dateFormat) {
    return null;
  }

  return format(date, dateFormat);
};

export const addDaysToDate = (value, numberOfDays) => {
  const date = toValidDate(value);

  return date ? addDays(date, numberOfDays) : null;
};

/**
 * Warranty is valid through the end of its displayed local calendar day.
 */
export const isOnOrAfterToday = (value) => {
  const date = toValidDate(value);

  if (!date) {
    return false;
  }

  return !isBefore(startOfDay(date), startOfDay(new Date()));
};
